import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { getExclusiveOffer, getLeadInOffer } from 'store/exclusiveOffer/exclusiveOfferSelectors';
import { Text, Flex } from '@qga/roo-ui/components';
import { format } from 'date-fns';
import pluralize from 'pluralize';
import OfferTerms from '../OfferTerms';

const Wrapper = styled(Flex)`
  border-left: 3px solid ${themeGet('colors.brand.primary')};
  padding-left: ${themeGet('space.3')};
`;

const ExclusiveOfferConditions = () => {
  const exclusiveOffer = useSelector(getExclusiveOffer);
  const { minNumberOfNights } = useSelector(getLeadInOffer);
  const startDate = format(new Date(exclusiveOffer.travelDates.start), 'dd MMM yyyy');
  const endDate = format(new Date(exclusiveOffer.travelDates.end), 'dd MMM yyyy');
  const minNumberOfNightsText = pluralize('night', minNumberOfNights, true);

  return (
    <Wrapper mt={[6, 6, 6]} mb={[6, 6, 0]} justifySelf="flex-end">
      <Text display="block" fontSize="base" color="greys.charcoal" data-testid="offer-conditions">
        Minimum {minNumberOfNightsText} stay. Travel period: {startDate} - {endDate}. <OfferTerms offer={exclusiveOffer} />
      </Text>
    </Wrapper>
  );
};

export default ExclusiveOfferConditions;
